module.exports = __webpack_public_path__ + "img/banner-indecopi.28da95a7.png";